export default __webpack_public_path__ + "static/media/card-default-school.e9b3fda7.png";